import styles from './App.module.css';
import { About } from './components/About';
import { HallOfShame } from './components/HallOfShame';
import { HoneypotIcon } from './components/HoneypotIcon';
import { Leaderboards } from './components/Leaderboards';
import { LiveFeed } from './components/LiveFeed';
import { StatPanels } from './components/StatPanels';
import { WorldMap } from './components/WorldMap';
import { useEventStream } from './lib/useEventStream';

export function App() {
  const { events, stats, status } = useEventStream();

  return (
    <div className={styles.app}>
      <header className={styles.header}>
        <div className={styles.brand}>
          <HoneypotIcon className={styles.logo} />
          <div>
            <h1 className={styles.title}>
              HONEYPOT<span className={styles.title2}>THEATER</span>
            </h1>
            <p className={styles.tagline}>
              Watch the internet try to break in. The bots never sleep.
            </p>
          </div>
        </div>
      </header>

      <StatPanels stats={stats} status={status} />

      <div className={styles.stage}>
        <section className={styles.mapCard} aria-label="Live attack map">
          <div className={styles.cardLabel}>attack map</div>
          <WorldMap events={events} />
        </section>
        <section className={styles.feedCard} aria-label="Live attack feed">
          <div className={styles.cardLabel}>live feed</div>
          <LiveFeed events={events} />
        </section>
      </div>

      <Leaderboards stats={stats} />
      <HallOfShame events={events} stats={stats} />
      <About />

      <footer className={styles.footer}>
        <span>Passive honeypot · observation only · IPs truncated to /24</span>
        <span>
          <a href="https://michaelweber.xyz" target="_blank" rel="noreferrer">
            michaelweber.xyz
          </a>
        </span>
      </footer>
    </div>
  );
}
